import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { syncSessionWithCookie } from './services/sessionCookie'

// Reconcile against the domain cookie before anything reads localStorage, so
// a session started on the other host is already in place on first render.
syncSessionWithCookie()

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
)
